import { Link, useLocation } from 'react-router-dom';
import { Home, Coins, PieChart, Settings as SettingsIcon } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

export default function Sidebar() {
  const location = useLocation();
  const { settings } = useSettings();

  const navItems = [
    { name: 'Dashboard', href: '/', icon: Home },
    ...(settings.showPortfolio ? [{ name: 'Portfolio', href: '/portfolio', icon: PieChart }] : []),
    { name: 'Settings', href: '/settings', icon: SettingsIcon },
  ];

  return (
    <aside className="hidden md:flex flex-col w-64 min-h-[calc(100vh-4rem)] bg-white dark:bg-black border-r border-gray-200 dark:border-gray-800 p-4">
      <nav className="space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                isActive
                  ? 'bg-gray-100 dark:bg-gray-800 text-black dark:text-white font-medium'
                  : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </nav>

      <div className="mt-auto pt-4 border-t border-gray-200 dark:border-gray-800">
        <div className="text-xs text-gray-500 dark:text-gray-500">
          <p>BlockPeek v1.0.0</p>
          <p className="mt-1">Real-time crypto tracking</p>
        </div>
      </div>
    </aside>
  );
}